module.exports = __webpack_public_path__ + "static/media/formulusblack.13a23ba9.svg";